export default __webpack_public_path__ + "static/media/Capitolo 2.9cdd7616.mp3";